import React from "react";
import PropTypes from "prop-types";

// components
import HeadingBadge from "../Components/Heading/HeadingBadge";

export default function ContactUsFooter({ headingBadge }) {
  return (
    <>
      <section className="py-8 bg-blueGray-900">
        <div className="mx-auto px-4">
          {headingBadge && <HeadingBadge {...headingBadge} />}
          <div className="mb-12 flex flex-wrap -mx-4 justify-center">
            <a
              color="lightBlue"
              size="lg"
              type="button"
              href="contactUs"
              className="text-lightBlue-500 bg-transparent border border-solid border-lightBlue-500 hover:bg-lightBlue-500 hover:text-white active:bg-lightBlue-600 font-bold uppercase text-sm px-6 py-3 rounded-full outline-none focus:outline-none mr-1 mb-12 ease-linear transition-all duration-150"
            >
              <i className={"fas fa-comment mr-2"}></i>
              Contact Us
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
ContactUsFooter.defaultProps = {
  card: {},
  headingBadge: null,
};
ContactUsFooter.propTypes = {
  // prop to pass to the Heading3Badge component
  headingBadge: PropTypes.object,
  // it is represented by the props
  // that can be passed to the CardContactUsTitle,
  // so please check that one out
  card: PropTypes.object,
};
